import React, { useEffect, useState } from "react";
import Carousel from "../components/Carousel";
import ImageScrollGallery from "../components/ImageScrollGallery";
import JournalCard from "../components/JournalCard";
import NewArticleCard from "../components/NewArticleCard";
import { Row, Col, Spinner } from "react-bootstrap"; // 引入 Spinner
import { getPublishedArticles } from "../server/api";
import { fetchJson } from "../utils/fetchJson";
import cmp from "../assets/ourJcr/cmp.jpg"; // 默认封面图
import cpa from "../assets/ourJcr/cpa.jpg";
import cg from "../assets/ourJcr/cg.jpg";
const HomePage = () => {
  const [articles, setArticles] = useState([]);
  const [journals, setJournals] = useState([]);
  const [page, setPage] = useState(1);
  const [limit] = useState(8); // 一页8条
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false); // 加载状态

  // 文章列表获取
  const handleFetchArticle = async (currentPage = 1) => {
    try {
      setLoading(true);
      const data = await getPublishedArticles({
        page: currentPage,
        limit,
        jcr: [
          "CURRENT MOLECULAR PHARMACOLOGY",
          "CURRENT PHARMACEUTICAL ANALYSIS",
          "CURRENT GENOMICS",
        ],
        order: "",
        years: [],
      });

      const fetched = Array.isArray(data.data) ? data.data : [];

      // 第一页覆盖，其余页追加
      if (currentPage === 1) {
        setArticles(fetched);
      } else {
        setArticles((prev) => [...prev, ...fetched]);
      }

      // 判断是否还有更多数据
      if (fetched.length < limit) {
        setHasMore(false);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // 侧边栏数据
  const fetchSidebar = () => {
    const fetch1 = fetchJson(
      "/json/volumes/volumes/current-molecular-pharmacology-volume.json"
    ).then((res) => res.json());
    const fetch2 = fetchJson(
      "/json/volumes/volumes/current-pharmaceutical-analysis-volume.json"
    ).then((res) => res.json());
    const fetch3 = fetchJson(
      "/json/volumes/volumes/current-genomics-volume.json"
    ).then((res) => res.json());
    Promise.all([fetch1, fetch2, fetch3])
      .then(([data1, data2, data3]) => {
        const list1 = data1.volumes[0].issues
          .sort((a, b) => b.id - a.id)
          .map((item) => ({
            ...item,
            volume: "18",
            name: "Current Molecular Pharmacology",
          }));
        const list2 = data2.volumes[0].issues
          .sort((a, b) => b.id - a.id)
          .map((item) => ({
            ...item,
            volume: "21",
            name: "Current Pharmaceutical Analysis",
          }));
        const list3 = data3.volumes[0].issues
          .sort((a, b) => b.id - a.id)
          .map((item) => ({
            ...item,
            volume: "21",
            name: "Current Genomics",
          }));
        const mergedList = [...list1, ...list2, ...list3];
        handleFetchSidebar(mergedList);
      })
      .catch((error) => console.error("Error loading volume data:", error));
  };

  // 获取侧边栏
  const handleFetchSidebar = async (arr) => {
    try {
      const response = await getPublishedArticles({
        jcr: [
          "CURRENT MOLECULAR PHARMACOLOGY",
          "CURRENT PHARMACEUTICAL ANALYSIS",
          "CURRENT GENOMICS",
        ],
        page: "",
        limit: "",
        order: "",
        years: [],
        opt: "issuelist",
      });

      const list = Array.isArray(response) ? response : response?.data || [];

      // 先合并封面
      const mapped = list.map((journal) => {
        const matched = arr.find(
          (a) =>
            String(a.issued).trim() === String(journal.issued).trim() &&
            String(a.volume).trim() === String(journal.volume).trim()
        );

        const cover_img = matched
          ? matched.cover_img
          : journal.jcr === "CURRENT MOLECULAR PHARMACOLOGY"
          ? cmp
          : journal.jcr === "CURRENT PHARMACEUTICAL ANALYSIS"
          ? cpa
          : journal.jcr === "CURRENT GENOMICS"
          ? cg
          : null;

        return {
          ...journal,
          cover_img,
          volume: Number(journal.volume),
          issued: Number(journal.issued),
        };
      });

      // ---- 关键函数：只取最新一期 ----
      const getLatestIssue = (journals) => {
        if (!journals.length) return null;

        // 1. 找最大 volume
        const maxVolume = Math.max(...journals.map((j) => j.volume));

        // 2. 找出该 volume 内 issued 最大的那一期
        const latest = journals
          .filter((j) => j.volume === maxVolume)
          .sort((a, b) => b.issued - a.issued)[0];

        return latest;
      };

      const cpaLatest = getLatestIssue(
        mapped.filter((j) => j.jcr === "CURRENT PHARMACEUTICAL ANALYSIS")
      );

      const cmpLatest = getLatestIssue(
        mapped.filter((j) => j.jcr === "CURRENT MOLECULAR PHARMACOLOGY")
      );

      const cgLatest = getLatestIssue(
        mapped.filter((j) => j.jcr === "CURRENT GENOMICS")
      );

      // 过滤掉 null
      setJournals([cpaLatest, cmpLatest,cgLatest].filter(Boolean));
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchSidebar();
    handleFetchArticle(1);
  }, []);

  // 加载更多文章
  const handleShowMore = async () => {
    const nextPage = page + 1;
    setPage(nextPage);
    await handleFetchArticle(nextPage);
  };

  return (
    <div>
      <div className="flex d-flex">
        <Row className="m-0" style={{ width: "100%" }}>
          <Col md={9} xs={12}>
            <Carousel />
            <div>
              <section className="articles-header mb-20">
                <h2 style={{ fontSize: "1.5rem" }}>Explore Our Journals</h2>
              </section>
              <ImageScrollGallery />
            </div>

            <div className="fade-in-up">
              <section className="articles-header mb-20">
                <h2 style={{ fontSize: "1.5rem" }}>Latest Articles</h2>
              </section>

              <section className="articles-section">
                <Row className="m-0 p-0" style={{ width: "100%" }}>
                  {articles
                    .slice()
                    .sort(
                      (a, b) =>
                        new Date(b.published_time) - new Date(a.published_time)
                    )
                    .map((article) => (
                      <Col key={article.id} md={12} xs={12} className="p-2">
                        <NewArticleCard article={article} />
                      </Col>
                    ))}

                  {articles.length === 0 && !loading && (
                    <div
                      style={{
                        width: "100%",
                        textAlign: "center",
                        padding: "20px",
                      }}
                    >
                      No articles found
                    </div>
                  )}
                </Row>

                {/* 按钮区 */}
                {hasMore && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginBottom: "20px",
                    }}
                  >
                    <button
                      onClick={handleShowMore}
                      disabled={loading} // 加载中禁用
                      style={{
                        padding: "8px 20px",
                        border: "1px solid #003366",
                        borderRadius: "4px",
                        backgroundColor: loading ? "#5a7499" : "#003366",
                        color: "white",
                        cursor: loading ? "not-allowed" : "pointer",
                        transition: "all 0.3s ease",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      {/* 加载中动画 */}
                      {loading && (
                        <Spinner animation="border" size="sm" role="status" />
                      )}
                      {loading ? "Loading..." : "Show more results"}
                    </button>
                  </div>
                )}
              </section>
            </div>
          </Col>

          <Col md={3} xs={12}>
            <aside className="mb-2">
              <div style={{ display: "flex", flexDirection: "column" }}>
                {journals.map((journal, index) => (
                  <JournalCard key={index} journal={journal} />
                ))}
                {journals.length === 0 && "No data"}
              </div>
            </aside>
            <>
              <div
                style={{
                  padding: "15px",
                  borderRadius: "8px",
                  background: "#ffffff",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                  marginTop: "20px",
                  marginBottom: "20px",
                }}
              >
                <h5
                  style={{
                    fontSize: "1rem",
                    fontWeight: "600",
                    color: "#003366",
                    lineHeight: "1.4",
                    marginBottom: "12px",
                  }}
                >
                  Special Issue on Polypharmacology in Cancer Therapy:
                  Overcoming Resistance and Enhancing Efficacy
                </h5>

                <div
                  style={{
                    width: "100%",
                    overflow: "hidden",
                    borderRadius: "6px",
                    marginBottom: "12px",
                  }}
                >
                  <img
                    src="/images/journals/cpa.jpg"
                    alt="Special Issue"
                    style={{
                      width: "100%",
                      height: "auto",
                      display: "block",
                    }}
                  />
                </div>

                <a
                  href="https://www.keaipublishing.com/en/journals/current-pharmaceutical-analysis/call-for-papers/polypharmacology-in-cancer-therapy-overcoming-resistance-and-enhancing-efficacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "block",
                    textAlign: "center",
                    padding: "10px 15px",
                    background: "#003366",
                    color: "#fff",
                    borderRadius: "6px",
                    fontWeight: "600",
                    letterSpacing: "0.5px",
                    fontSize: "0.9rem",
                    textDecoration: "none",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.target.style.opacity = "0.85")}
                  onMouseLeave={(e) => (e.target.style.opacity = "1")}
                >
                  SUBMIT BY 10 JULY 2026
                </a>
              </div>
            </>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default HomePage;
